document.documentElement.classList.add('custom-js');

/* =========================================================
   HOMEPAGE HEADER + HERO LOGO
   Desktop: logo beweegt naar de header
   Mobiel: logo verkleint subtiel en vervaagt
   ========================================================= */

class EditorialHomepageAnimation {
  constructor() {
    this.hero = document.querySelector('[data-editorial-hero]');
    this.heroLogoWrap = document.querySelector('[data-hero-logo]');
    this.headerLogo = document.querySelector('.header__heading-logo');
    this.header = document.querySelector(
      '#shopify-section-header, .section-header'
    );

    if (
      !this.hero ||
      !this.heroLogoWrap ||
      !this.headerLogo ||
      !this.header ||
      !document.body.classList.contains('template-index')
    ) {
      return;
    }

    this.ticking = false;
    this.logoIsHidden = false;
    this.startRect = null;
    this.targetRect = null;

    this.requestUpdate = this.requestUpdate.bind(this);
    this.update = this.update.bind(this);
    this.measure = this.measure.bind(this);

    this.measure();
    this.update();

    window.addEventListener('scroll', this.requestUpdate, {
      passive: true
    });

    window.addEventListener('resize', () => {
      this.measure();
      this.requestUpdate();
    });
  }

  clamp(value, minimum = 0, maximum = 1) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  easeInOut(progress) {
    return progress < 0.5
      ? 2 * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 2) / 2;
  }

  smoothstep(start, end, value) {
    const progress = this.clamp(
      (value - start) / (end - start)
    );

    return progress * progress * (3 - 2 * progress);
  }

  measure() {
    this.heroLogoWrap.style.transform =
      'translate3d(-50%, -50%, 0) scale(1)';

    this.startRect =
      this.heroLogoWrap.getBoundingClientRect();

    this.targetRect =
      this.headerLogo.getBoundingClientRect();
  }

  requestUpdate() {
    if (this.ticking) return;

    this.ticking = true;

    window.requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    if (!this.startRect || !this.targetRect) return;

    const heroHeight = this.hero.offsetHeight;
    const headerHeight =
      this.header.getBoundingClientRect().height;

    const animationDistance = Math.max(
      heroHeight - headerHeight,
      1
    );

    const rawProgress = this.clamp(
      window.scrollY / animationDistance
    );

    const isMobile =
      window.matchMedia('(max-width: 749px)').matches;

    /* Header wordt wit zodra de hero voorbij de header komt. */
    const heroBottom =
      this.hero.getBoundingClientRect().bottom;

    document.body.classList.toggle(
      'header-is-solid',
      heroBottom <= headerHeight
    );

    const startCenterX =
      this.startRect.left + this.startRect.width / 2;

    const startCenterY =
      this.startRect.top + this.startRect.height / 2;

    const targetCenterX =
      this.targetRect.left + this.targetRect.width / 2;

    const targetCenterY =
      this.targetRect.top + this.targetRect.height / 2;

    let moveX = 0;
    let moveY = 0;
    let currentScale = 1;
    let logoOpacity = 1;

    if (isMobile) {
      /*
        Mobiel:
        geen zware verplaatsing naar de header.
        Alleen subtiel verkleinen en vervagen.
      */
      currentScale = 1 - rawProgress * 0.16;

      logoOpacity =
        1 - this.smoothstep(0.72, 0.96, rawProgress);

      document.documentElement.style.setProperty(
        '--hero-logo-invert',
        '1'
      );
    } else {
      /*
        Desktop:
        volledige beweging naar de header.
      */
      const movementProgress =
        this.easeInOut(rawProgress);

      moveX =
        (targetCenterX - startCenterX) *
        movementProgress;

      moveY =
        (targetCenterY - startCenterY) *
        movementProgress;

      const targetScale = this.clamp(
        this.targetRect.width / this.startRect.width,
        0.01,
        1
      );

      currentScale =
        1 +
        (targetScale - 1) *
        movementProgress;

      const blackProgress =
        this.smoothstep(0.88, 1, rawProgress);

      const invertValue =
        1 - blackProgress;

      document.documentElement.style.setProperty(
        '--hero-logo-invert',
        invertValue.toFixed(3)
      );
    }

    this.heroLogoWrap.style.transform = `
      translate3d(-50%, -50%, 0)
      translate3d(
        ${moveX.toFixed(2)}px,
        ${moveY.toFixed(2)}px,
        0
      )
      scale(${currentScale.toFixed(4)})
    `;

    const shouldHideLogo =
      rawProgress >= 0.999;

    if (shouldHideLogo) {
      logoOpacity = 0;
    }

    this.heroLogoWrap.style.opacity =
      String(logoOpacity);

    if (shouldHideLogo !== this.logoIsHidden) {
      this.logoIsHidden = shouldHideLogo;

      this.heroLogoWrap.style.visibility =
        shouldHideLogo ? 'hidden' : 'visible';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new EditorialHomepageAnimation();
});
/* =========================================================
   CUSTOM PRODUCT — VIDEO AUTOPLAY + LOOP
   ========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  if (
    !document.body.classList.contains(
      'template-suffix-custom-product'
    )
  ) {
    return;
  }

  

  const prepareVideo = (video) => {
    if (!video || video.dataset.autoplayReady === 'true') {
      return;
    }

    video.dataset.autoplayReady = 'true';

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.controls = false;

    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');

    const startVideo = () => {
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          /* Browser probeert opnieuw zodra de video klaar is. */
        });
      }
    };

    if (video.readyState >= 2) {
      startVideo();
    } else {
      video.addEventListener('loadeddata', startVideo, {
        once: true
      });
    }
  };

  const initialiseProductVideos = () => {
    document
      .querySelectorAll(
        '.custom-product-media deferred-media'
      )
      .forEach((deferredMedia) => {
        const existingVideo =
          deferredMedia.querySelector('video');

        if (existingVideo) {
          prepareVideo(existingVideo);
          return;
        }

        /*
          Dawn laadt de echte video pas wanneer deze posterknop
          wordt geactiveerd.
        */
        const posterButton = deferredMedia.querySelector(
          '.deferred-media__poster'
        );

        if (posterButton) {
          posterButton.click();
        }
      });

    document
      .querySelectorAll('.custom-product-media video')
      .forEach(prepareVideo);
  };

  initialiseProductVideos();

  /*
    Controleert opnieuw zodra Dawn de video vanuit het
    <template>-element in de pagina plaatst.
  */
  const observer = new MutationObserver(() => {
    initialiseProductVideos();
  });

  const mediaArea = document.querySelector(
    '.custom-product-media'
  );

  if (mediaArea) {
    observer.observe(mediaArea, {
      childList: true,
      subtree: true
    });
  }
});

